import {useToast} from 'vue-toastification'

interface Toast {
    error: (msg: string) => void
    success: (msg: string) => void
    info: (msg: string) => void
    warning: (msg: string) => void
}

const toaster = useToast()

export const toast: Toast = {
    error: (msg: string) => {
        toaster.error(msg)
    },

    success: (msg: string) => {
        toaster.success(msg)
    },

    info: (msg: string) => {
        toaster.info(msg)
    },

    warning: (msg: string) => {
        toaster.warning(msg)
    },
}
